export default __webpack_public_path__ + "static/media/dream-world.80526adb.jpg";